import {
  FaHome,
  FaUser,
  FaChartLine,
  FaFileAlt,
  FaPhone,
  FaMoneyBill,
  FaGift,
  FaVideo,
  FaCog,
  FaSignOutAlt,
  FaList,
  // FaTags,
  FaNewspaper,
  FaComments,
  FaCogs,
  FaImage,
  FaWallet,
  FaMapMarkerAlt,
  FaBuilding,
  FaBook,
  FaStar,
  FaCogs as FaSettings,
  FaEnvelope,
  FaGlobe,
  FaLanguage,
  FaBell,
  FaUserCheck,
  FaHandHoldingUsd,
  FaBox,
  FaShoppingCart ,
  FaPrayingHands ,
  FaClipboardList ,
  FaEdit ,
  FaTags ,
  FaUserSlash,
  FaUserShield,
} from "react-icons/fa";

export const sidebarMenu = [
  {
    label: "Dashboard",
    icon: <FaHome className="w-5 h-5 " />,
    route: "/",
  },
  // {
  //   label: "Sub Admin",
  //   icon: <FaUserShield  className="w-5 h-5 " />,
  //   route: "/sub-admin",
  // },
  // {
  //   label: "Role",
  //   icon: <FaUserCheck className="w-5 h-5 " />,
  //   route: "/role",
  // },
  // {
  //   label: "Astrologer",
  //   icon: <FaChartLine className="w-5 h-5 " />,
  //   route: "/astrologer",
  // },
  // {
  //   label: "AstroLoger Requests",
  //   icon: <FaComments className="w-5 h-5"/>,
  //   route: "/astroLogerRequest"
  // },
  // {
  //   label: "User",
  //   icon: <FaUser className="w-5 h-5 " />,
  //   route: "/user",
  // },
  // {
  //   label : "Inactive User Logs",
  //   icon : <FaUserSlash  className="w-5 h-5"/>,
  //   route:"/inactive-user"
  // },
  // {
  //   label: "Call History",
  //   icon: <FaMoneyBill className="w-5 h-5 " />,
  //   route: "/callHistory",
  // },
  // {
  //   label: "Missed Call",
  //   icon: <FaPhone className="w-5 h-5 " />,
  //   route: "/missed-call",
  // },
  // {
  //   label: "Category",
  //   route: "/category",
  //   icon: <FaTags  className="w-5 h-5 " />,
  // },
  // {
  //   label: "Product",
  //   icon: <FaBox className="w-5 h-5 " />,
  //   route: "/product",
  // },
  // {
  //   label: "Manage Orders",
  //   icon: <FaShoppingCart  className="w-5 h-5 " />,
  //   route: "/product-booking-list",
  // },
  // {
  //   label: "Pooja",
  //   icon: <FaPrayingHands  className="w-5 h-5 " />,
  //   route: "/pooja",
  // },

  // {
  //   label: "Pooja Booking List",
  //   icon: <FaClipboardList  className="w-5 h-5 " />,
  //   route: "/pooja-booking-list",
  // },

  // {
  //   label: "Chadawa",
  //   icon: <FaHandHoldingUsd  className="w-5 h-5 " />,
  //   route: "/Chadawa-Booking-Page",
  // },

  // {
  //   label: "Chadawa Booking List",
  //   icon: <FaClipboardList className="w-5 h-5 " />,
  //   route: "/Chadawa-Booking-List-Page",
  // },

  // {
  //   label: "Editor",
  //   icon: <FaEdit  className="w-5 h-5 " />,
  //   route: "/editor",
  // },

  // {
  //   label: "AstroSetu Query",
  //   icon: <FaComments className="w-5 h-5 " />,
  //   route: "/queryform",
  // },

{
   label: "Query Form",
   icon: <FaComments className="w-5 h-5" />,
   route: "/jkm-query",
},

  // {
  //   label: "Recharge Offer",
  //   icon: <FaGift className="w-5 h-5 " />,
  //   route: "/recharge-offer",
  // },

  // {
  //   label: "GST",
  //   icon: <FaFileAlt className="w-5 h-5 " />,
  //   route: "/gst",
  // },
  // {
  //   label: "Tax",
  //   icon: <FaFileAlt className="w-5 h-5 " />,
  //   subMenu: [
  //     {
  //       label: "GST",
  //       route: "/tax/gst",
  //       icon: <FaFileAlt className="w-5 h-5 " />,
  //     },
  //     {
  //       label: "TDS",
  //       route: "/tax/tds",
  //       icon: <FaFileAlt className="w-5 h-5 " />,
  //     },
  //   ],
  // },

  // {
  //   label: "Report",
  //   icon: <FaFileAlt className="w-5 h-5 " />,
  //   route: "/report",
  // },
  // {
  //   label: "Gift",
  //   icon: <FaGift className="w-5 h-5 " />,
  //   route: "/gift",
  // },
  // {
  //   label: "Live",
  //   icon: <FaVideo className="w-5 h-5 " />,
  //   route: "/live",
  // },
  // {
  //   label: "Coupon",
  //   icon: <FaTags className="w-5 h-5 " />,
  //   route: "/coupon",
  // },
  // {
  //   label: "CMS",
  //   icon: <FaNewspaper className="w-5 h-5 " />,
  //   subMenu: [
  //     {
  //       label: "Banner",
  //       route: "/cms/banner",
  //       icon: <FaImage className="w-5 h-5 " />,
  //     },
  //     {
  //       label: "Blog",
  //       route: "/cms/blog",
  //       icon: <FaBook className="w-5 h-5 " />,
  //     },
  //     // {
  //     //   label: "Blog Category",
  //     //   route: "/cms/blog-category",
  //     //   icon: <FaList className="w-5 h-5 " />,
  //     // },
  //     // {
  //     //   label: "Testimonials",
  //     //   route: "/cms/testimonials",
  //     //   icon: <FaStar className="w-5 h-5 " />,
  //     // },
  //     {
  //       label: "Site Settings",
  //       route: "/cms/site-setting",
  //       icon: <FaCog className="w-5 h-5 " />,
  //     },
  //   ],
  // },

  // {
  //   label: "Astrologer Request",
  //   icon: <FaComments className="w-5 h-5 " />,
  //   subMenu: [
  //     {
  //       label: "Bank Request",
  //       route: "/bank-request",
  //       icon: <FaBuilding className="w-5 h-5 " />,
  //     },

  //     // {
  //     //   label: "Call Request",
  //     //   route: "/astrologer-request/call-request",
  //     //   icon: <FaPhone className="w-5 h-5 " />,
  //     // },
  //     {
  //       label: "Redeem Request",
  //       route: "/redeem-request",
  //       icon: <FaHandHoldingUsd className="w-5 h-5 " />,
  //     },
  //   ],
  // },  
  // {
  //   label: "Utility",
  //   icon: <FaCogs className="w-5 h-5 " />,
  //   subMenu: [
  //     // {
  //     //   label: "Video",
  //     //   route: "/utility/video",
  //     //   icon: <FaVideo className="w-5 h-5 " />,
  //     // },
  //     {
  //       label: "Offers",
  //       route: "/utility/offers",
  //       icon: <FaTags className="w-5 h-5 " />,
  //     },
  //     {
  //       label: "Language",
  //       route: "/utility/language",
  //       icon: <FaLanguage className="w-5 h-5 " />,
  //     },
  //     // {
  //     //   label: "Report Type",
  //     //   route: "/utility/report-type",
  //     //   icon: <FaFileAlt className="w-5 h-5 " />,
  //     // },

  //     {
  //       label: "Skill",
  //       route: "/utility/skill",
  //       icon: <FaCogs className="w-5 h-5 " />,
  //     },
  //     {
  //       label: "Notifications",
  //       route: "/utility/notifications",
  //       icon: <FaBell className="w-5 h-5 " />,
  //     },

  //     // {
  //     //   label: "Contact Us",
  //     //   route: "/utility/contact-us",
  //     //   icon: <FaEnvelope className="w-5 h-5 " />,
  //     // },
  //     // {
  //     //   label: "Wallet Amount",
  //     //   route: "/utility/wallet-amount",
  //     //   icon: <FaWallet className="w-5 h-5 " />,
  //     // },
  //   ],
  // },
  // {
  //   label: "Location",
  //   icon: <FaMapMarkerAlt className="w-5 h-5 " />,
  //   subMenu: [
  //     {
  //       label: "Country",
  //       route: "/location/country",
  //       icon: <FaGlobe className="w-5 h-5 " />,
  //     },
  //     {
  //       label: "State",
  //       route: "/location/state",
  //       icon: <FaMapMarkerAlt className="w-5 h-5 " />,
  //     },
  //     {
  //       label: "City",
  //       route: "/location/city",
  //       icon: <FaMapMarkerAlt className="w-5 h-5 " />,
  //     },
  //   ],
  // },
  {
    label: "Logout",
    icon: <FaSignOutAlt className="w-5 h-5 " />,
    route: "/logout",
  },
];
